module.exports = __webpack_public_path__ + "img/logoemi.9d5c4b9f.png";